/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_summary_description_show_less26 = /** @type {(inputs: {}) => string} */ () => {
	return `Show Less`
};

const fr_summary_description_show_less26 = /** @type {(inputs: {}) => string} */ () => {
	return `Montrer Moins`
};

const de_summary_description_show_less26 = /** @type {(inputs: {}) => string} */ () => {
	return `Weniger zeigen`
};

const es_summary_description_show_less26 = /** @type {(inputs: {}) => string} */ () => {
	return `Mostrar menos`
};

const it_summary_description_show_less26 = /** @type {(inputs: {}) => string} */ () => {
	return `Mostra meno`
};

const ar_summary_description_show_less26 = /** @type {(inputs: {}) => string} */ () => {
	return `عرض أقل`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const summary_description_show_less26 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.summary_description_show_less26(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("summary_description_show_less26", locale)
	if (locale === "en") return en_summary_description_show_less26(inputs)
	if (locale === "fr") return fr_summary_description_show_less26(inputs)
	if (locale === "de") return de_summary_description_show_less26(inputs)
	if (locale === "es") return es_summary_description_show_less26(inputs)
	if (locale === "it") return it_summary_description_show_less26(inputs)
	return ar_summary_description_show_less26(inputs)
};
export { summary_description_show_less26 as "SUMMARY_DESCRIPTION_SHOW_LESS" }